import { isModalRAQ } from '../../core/utils';
riot.tag2('raq-vehicle-container', '<yield></yield>', '', '', function(opts) {
    /* global Acr */
    /* global UDO */
    const self = this;
    const axios = require('axios');
    const productDivisionCode = require('../../data/placeHolderCopy').productDivisionCode;
    const vehicle = require('../../core/vehicle');
    const params = require('../../core/params');
    const ERRORS = require('../../core/platform/errors.js').default;
    const dealersSvc = require('../../core/dealers.js');
    const trackingHandler = require('../../core/trackingManager');

    this.mixin('bus');
    this.mixin('storage');

    self.isModalRAQ = isModalRAQ();
    self.triggerUpdate = true;
    self.vehicle = {};
    self.taxonomy = null;
    self.showEdit = false;

    const divCode = window.raq && window.raq.productDivisionCode ? window.raq.productDivisionCode : productDivisionCode;

    let carData = null;
    let userData = null;
    let pageloadTriggered = false;
    let vehicleSelected = null;

    function sendtrackingPageload() {
      userData = params.userData();
      if (userData.localDealerId && !userData.localDealerZip) {
        dealersSvc.getDealer(userData.localDealerId).then((dealerObj) => {
          userData.localDealerZip = dealerObj.zip;
          userData.localDealerName = dealerObj.name;
          userData.localDealerAddress = dealerObj.address;
          userData.localDealerPhone = dealerObj.phone;
        });
      }
      const trackingObject = trackingHandler.createPageloadObject(userData, carData);
      if (Acr.TrackingManager && !pageloadTriggered && self.userData.userZipCode) {
        Acr.TrackingManager.pageLoad(trackingObject);
        pageloadTriggered = true;
      } else {
        // TrackingManager.js is loaded. Used to avoid dependencies issues.
        window.addEventListener('trackingPageload', () => {
          if (!pageloadTriggered && self.userData.userZipCode) {
            Acr.TrackingManager.pageLoad(trackingObject);
            pageloadTriggered = true;
          }
        });
      }
    }

    // checks if the details query url returns successfully and if not it uses the basic query
    function checkDetailsQuery(query, detailsQuery, basicQuery) {
      axios.get(query)
        .then(() => {
          // uses the details query
          detailsQuery();
        })
        .catch(() => {
          // uses the basicQuery
          basicQuery();
        });
    }

    function buildDetailsQuery() {
      let query = `${self.getLabel('endpoints.vehicleCardDetail')}`
        + `?productDivisionCode=${divCode}`
        + `&modelYear=${self.userData.carModelYear}`
        + `&modelGroup=${self.userData.carModelName}`
        + `&exteriorColorCode=${self.userData.exteriorColorCode}`
        + `&interiorColorCode=${self.userData.interiorColorCode}`
        + `&exteriorColorIdent=${self.userData.exteriorColorIdent}`
        + `&interiorColorIdent=${self.userData.interiorColorIdent}`
        + `&modelId=${self.userData.modelId}`
        + `&zipCode=${self.userData.userZipCode}`
        + '&maxdealers=1&trimgroupfilter=true';
      if (self.userData.localDealerId) {
        query += `&preferredDealerId=${self.userData.localDealerId}`;
      }

      return query;
    }

    function buildDataQuery() {
      const query = `${self.getLabel('endpoints.vehicleCardData')}`
        + `?productDivisionCode=${divCode}`
        + `&exteriorColorCode=${self.userData.exteriorColorCode}`
        + `&interiorColorCode=${self.userData.interiorColorCode}`
        + `&modelId=${self.userData.modelId}`;
      return query;
    }

    function buildBasicQuery() {
      const year = self.userData.carModelYear ? self.userData.carModelYear : '0';
      return `${self.getLabel('endpoints.vehicleCardBasic')}`
        + `/${year}/${self.userData.carModelName}`;
    }

    function createModelData(modelInfo) {
      const raqIsModal = window.Acr && window.Acr.backupTrackingObject;
      if (!raqIsModal && modelInfo && modelInfo.name) {
        window.ModelData = window.ModelData || {};
        window.ModelData.modelYear = modelInfo.year || '';
        window.ModelData.model = modelInfo.name;
        window.ModelData.modelId = modelInfo.modelId || '';
      }
    }

    function vehicleCallback(vehicleData) {
      self.vehicle = vehicleData;
      if (vehicleData && vehicleData.colors) {
        params.setVehicleColors(vehicleData.colors);
      }
      if (vehicleData && vehicleData.name) {
        params.setVehicleName(vehicleData.name);
      }
      if (vehicleData && vehicleData.year) {
        params.setVehicleYear(vehicleData.year);
      }
      if (vehicleData && vehicleData.modelmarketingname) {
        params.setVehicleModelMarketingName(vehicleData.modelmarketingname);
      }
      if (vehicleData) {
        carData = Object.assign(vehicleData);
        if (!window.ModelData) {
          createModelData(vehicleData);
        }
      }
      if (!pageloadTriggered) {
        sendtrackingPageload();
      }
      self.update();
      self.bus.trigger(self.bus.EVENTS.VEHICLE.UPDATED);
    }

    function handleError(error) {
      window.console.warn(ERRORS.endpointFailed, error);
      if (error && error.response && error.response.status && error.response.status === 500) {
        self.bus.trigger(self.bus.EVENTS.CONTAINER.ERROR);
      }
    }

    function vehicleSelection(data) {
      const vehicleData = (typeof data !== 'undefined') ? data : null;
      vehicleCallback(vehicleData);
      self.showEdit = false;
      if (!self.taxonomy) {
        vehicle.taxonomy(self.endpoints.vehicleTaxonomy)
          .then((taxonomy) => {
            if (taxonomy && taxonomy.Results) {
              self.taxonomy = taxonomy.Results;
              self.update();
              self.bus.trigger(self.bus.EVENTS.VEHICLE.TAXONOMYUPDATED, self.taxonomy);
            }
          })
          .catch(handleError);
      }
    }

    function getVehicleData() {
      self.userData = params.userData();
      if (self.userData.carModelName && self.userData.carModelYear
          && self.userData.userZipCode && self.userData.modelId
          && self.userData.exteriorColorCode && self.userData.interiorColorCode) { // Inv params passed
        const query = buildDetailsQuery();
        const detailsQuery = () => {
          vehicle.details(query)
            .then((vehicleData) => {
              vehicleCallback(vehicleData);
            })
            .catch((error) => {
              vehicleCallback(null); // Clear vehicle data
              handleError(error); // Show console warnings or 500 error screen
              vehicleSelection(); // Show Vehicle selection component
            });
        };
        const basicQuery = () => {
          vehicle.basic(buildBasicQuery())
            .then((vehicleData) => {
              vehicleCallback(vehicleData);
              return vehicleData;
            })
            .catch((error) => {
              vehicleCallback(null); // Clear vehicle data
              handleError(error); // Show console warnings or 500 error screen
              vehicleSelection(); // Show Vehicle selection component
            });
        };
        checkDetailsQuery(query, detailsQuery, basicQuery);
      } else if (self.userData.modelId && self.userData.exteriorColorCode
        && self.userData.interiorColorCode) { // No dealer/zipcode params passed
        vehicle.data(buildDataQuery())
          .then((vehicleData) => {
            vehicleCallback(vehicleData);
          })
          .catch((error) => {
            vehicleCallback(null); // Clear vehicle data
            handleError(error); // Show console warnings or 500 error screen
            vehicleSelection(); // Show Vehicle selection component
          });
      } else if (self.userData.carModelName) {
        if (vehicleSelected && self.userData.source !== 'offers') {
          vehicleCallback(vehicleSelected);
        } else {
          // Vehiclemodelseries/year only (Year it's optional)
          vehicle.basic(buildBasicQuery())
            .then((vehicleData) => {
              let urlParams = params.userData().urlParams;
              if (urlParams && urlParams.showvehicleselector && urlParams.showvehicleselector === 'true') {
                vehicleSelection(vehicleData);
              }
              vehicleCallback(vehicleData);
            })
            .catch((error) => {
              vehicleCallback(null); // Clear vehicle data
              handleError(error); // Show console warnings or 500 error screen
              vehicleSelection(); // Show Vehicle selection component
            });
        }
      } else {
        vehicleSelection();
      }
    }

    function selectVehicle(data) {
      params.setUserVehicle(data);
      vehicleSelected = {
        name: data.modelSeries,
        trim: data.modelSeries,
        modelmarketingname: data.modelSeries,
        year: parseInt(data.modelYear, 10),
        imageDisclaimer: null,
      };
      getVehicleData();
      self.showEdit = true;
    }

    function updateVehicle() {
      self.userData = params.userData();
      getVehicleData();
    }

    function resetVehicle() {
      vehicleCallback(null);
      params.unsetVehicle();
      self.showEdit = false;
    }

    function updateState(data) {
      self.state = data.state;

      self.update();
    }

    function goBack() {
      self.bus.trigger(self.bus.EVENTS.VEHICLE.BACK_TO_MODELS);
    }

    self.changeSelection = resetVehicle;
    self.goBack = goBack;

    self.bus.on(self.bus.EVENTS.CONTAINER.MOUNTED, updateVehicle);
    self.bus.on(self.bus.EVENTS.VEHICLE.RESET, resetVehicle);
    self.bus.on(self.bus.EVENTS.VEHICLE.SELECTED, selectVehicle);
    self.bus.on(self.bus.EVENTS.VEHICLE.UPDATE, updateVehicle);
    self.bus.on(self.bus.EVENTS.VEHICLE.STATE_UPDATED, updateState);

});
